import CustomLayout from "./wrapPageElement";
import "./src/styles/GlobalStyle";

export const wrapPageElement = CustomLayout;
